var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointerUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.3423C19 10.9657 18.0412 9.76578 16.6745 9.4319L10.813 8V3.5C10.813 2.67157 10.1257 2 9.27792 2C8.43013 2 7.74285 2.67157 7.74285 3.5V12.5L6.41588 10.4253C5.78588 9.44037 4.38195 9.28413 3.54143 10.1054C2.99183 10.6425 2.84477 11.4582 3.17346 12.1464L6.20779 18.5C7.13905 20.6233 9.27567 22 11.6398 22H13.8831C16.7091 22 19 19.7614 19 17V12.3423Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerUp);
export default __webpack_public_path__ + "static/media/pointer-up.2b3d02bbdcc62911a82d50bacde5f766.svg";
export { ForwardRef as ReactComponent };